var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { ButtonBase } from '../../core/ButtonBase';
export var SmallButtonComponent = function (_a, ref) {
    var _b = _a.theme, theme = _b === void 0 ? 'secondary' : _b, props = __rest(_a, ["theme"]);
    return (React.createElement(ButtonBase, __assign({ component: "button", type: "button", ref: ref, theme: theme }, props, { save: false, small: true, success: false, width: "standard" })));
};
/**
 * @tdr
 * @tdr-candidates: button
 */
export var SmallButton = forwardRef(SmallButtonComponent);
//# sourceMappingURL=SmallButton.js.map